import { render, staticRenderFns } from "./ServiceDashboard.vue?vue&type=template&id=03b3793c&scoped=true"
import script from "./ServiceDashboard.vue?vue&type=script&lang=js"
export * from "./ServiceDashboard.vue?vue&type=script&lang=js"
import style0 from "./ServiceDashboard.vue?vue&type=style&index=0&id=03b3793c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b3793c",
  null
  
)

export default component.exports